import React from "react";
import styled from "styled-components";
import moment from "moment";

import LogoInput from "../Component/LogoInput";
import SouvenirInput from "../Component/SouvenirInput";
import TicketView from "./TicketView";
import SettingDateSelectView from "./SettingDateSelectView";

export default function SettingView(props) {
  const {
    mainPictureSize,
    bannerPictureWidth,
    bannerPictureHeight,
    commonSouvenirWidth,
    commonSouvenirHeight,
    plusWidth,
    plusHeight,

    title, 
    mainPicture, 
    setMainPicture,
    bannerPicture, 
    setBannerPicture,
    content, 
    period, 
    startDate, 
    startTime, 
    endDate, 
    endTime, 
    place, 
    subjectivity, 
    sponsor,
    souvenirPicture, 
    setSouvenirPicture,
  } = props;

  return (
    <TopLevelWrapper>
      <ViewBox>
        <ViewInnerBox>
          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>이벤트 이름</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>이벤트의 브랜드를 강활할 수 있는 직관적인 이름을 선택하세요</Text>
            </TitleWrapper>
            <TitleInputView>
              <Text fontFamily='NotoSansKR-Black' fontSize={21} color='#FFFFFF' cursor='default'>{title}</Text>
            </TitleInputView>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <TitleInnerWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>이벤트 홍보 사진</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={16} color='#FFFFFF' cursor='default'>(정방향 1080x1080, 가로형 1920x830)</Text>
              </TitleInnerWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>이벤트의 분위기를 한눈에 전달할 수 있는 이미지를 업로드하세요</Text>
            </TitleWrapper>
            <LogoInput 
              enabled={false}
              mainPictureSize={mainPictureSize}
              bannerPictureWidth={bannerPictureWidth}
              bannerPictureHeight={bannerPictureHeight}
              plusWidth={plusWidth}
              plusHeight={plusHeight}

              mainPicture={mainPicture}
              setMainPicture={setMainPicture}
              bannerPicture={bannerPicture}
              setBannerPicture={setBannerPicture}/>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>이벤트 내용</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>이벤트의 특장점과 차별점을 강조하여 더 많은 관심을 유도하세요</Text>
            </TitleWrapper>
            <InputView>
              <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='default'>{content}</PreText>
            </InputView>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>대회 기간</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>예선, 본선, 결승 등 세부 일정이 있는 경우 상세히 기재하세요</Text>
            </TitleWrapper>
            <InputView>
              <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='default'>{period}</PreText>
            </InputView>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>신청 기간 [설정에서 변경 가능]</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>신청 마감 이후에는 접수가 불가능하니 충분한 기간을 설정하세요</Text>
            </TitleWrapper>
            <SettingDateSelectView
              startDate={startDate} 
              startTime={startTime}
              endDate={endDate}
              endTime={endTime}/>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>대회 장소</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>참가자와 관중이 쉽게 찾아올 수 있도록 주소를 상세히 기재하세요</Text>
            </TitleWrapper>
            <InputView>
              <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='default'>{place}</PreText>
            </InputView>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>대회 주관사</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>대회를 주최·운영하는 기관, 단체 또는 기업의 이름을 입력하세요</Text>
            </TitleWrapper>
            <InputView>
              <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='default'>{subjectivity}</PreText>
            </InputView>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>대회 후원사</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>대회를 지원하는 기업, 단체 또는 기관의 이름을 입력하세요</Text>
            </TitleWrapper>
            <InputView>
              <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' cursor='default'>{sponsor}</PreText>
            </InputView>
          </ComponentWrapper>

          <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>공통 기념품</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>모든 참가자에게 제공되는 기념품 목록을 확인하세요</Text>
            </TitleWrapper>
            <SouvenirInput 
              enabled={false}
              commonSouvenirWidth={commonSouvenirWidth}
              commonSouvenirHeight={commonSouvenirHeight}
              plusWidth={plusWidth}
              plusHeight={plusHeight}
              souvenirPicture={souvenirPicture} 
              setSouvenirPicture={setSouvenirPicture}/>
          </ComponentWrapper>

          {/* <ComponentWrapper>
            <TitleWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>이벤트 티켓 내용</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>티켓 이름, 참가 자격, 참가 지침, 참가비, 대회 장소, 티켓별 대표 이미지를 설정하세요</Text>
            </TitleWrapper>
            <TicketViewWrapper>
              {
                tickets.map((data, index) => (
                  <TicketView 
                    key={'TicketView-' + index}
                    data={data}
                    index={index}

                    enabled={false}

                    pictureSize={mainPictureSize}
                    plusWidth={plusWidth}
                    plusHeight={plusHeight}
                    
                    onChangeAppliedTicketName={onChangeAppliedTicketName}
                    onChangeAppliedEntryQualification={onChangeAppliedEntryQualification}
                    onChangeAppliedIsUseSelectOption={onChangeAppliedIsUseSelectOption}
                    onChangeAppliedAddSelectOption={onChangeAppliedAddSelectOption}
                    onChangeAppliedDeleteSelectOption={onChangeAppliedDeleteSelectOption}
                    onChangeAppliedSelectOptionName={onChangeAppliedSelectOptionName}
                    onChangeAppliedIsUseParticipantLimit={onChangeAppliedIsUseParticipantLimit}
                    onChangeAppliedParticipantLimit={onChangeAppliedParticipantLimit}
                    onChangeAppliedTeamMemberCount={onChangeAppliedTeamMemberCount}
                    onChangeAppliedAdditionalInstaructions={onChangeAppliedAdditionalInstaructions}
                    onChangeAppliedIsUsePriceOption={onChangeAppliedIsUsePriceOption}
                    onChangeAppliedAddPriceOption={onChangeAppliedAddPriceOption}
                    onChangeAppliedDeletePriceOption={onChangeAppliedDeletePriceOption}
                    onChangeAppliedPriceOptionAppliedDate={onChangeAppliedPriceOptionAppliedDate}
                    onChangeAppliedPriceOptionName={onChangeAppliedPriceOptionName}
                    onChangeAppliedPriceOptionPrice={onChangeAppliedPriceOptionPrice}
                    onChangeAppliedPlace={onChangeAppliedPlace}
                    onChangeAppliedTicketThumbnail={onChangeAppliedTicketThumbnail}
                    onClickAppliedDeleteTicket={onClickAppliedDeleteTicket}/>
                ))
              }
            </TicketViewWrapper>
          </ComponentWrapper> */}
        </ViewInnerBox>
      </ViewBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper =  styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 0px;

  width: 98%;

  border-radius: 20px;
  background-color: #17171B;
`;

const ViewInnerBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 93%;

  gap: 34px;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 16px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const TitleInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const TitleInputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 15px 15px 16px 15px;

  width: calc(100% - 34px);

  border: 2px solid #909090;
  border-radius: 5px;
  background-color: #2F2F32;
`;


const InputView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 15px 15px;

  width: calc(100% - 34px);

  border: 2px solid #909090;
  border-radius: 5px;
  background-color: #2F2F32;
`;

const TicketViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 24px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: pre-wrap;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;